import { ForwardRefRenderFunction, forwardRef, Suspense } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { ChoiceBaseProps, NumberInputProps } from "models/propTypes/wintFormPropsTypes";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ChoiceBinary, NumberInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
import { WidgetBanner } from "components/common";
import { Skeleton } from "@mui/material";
import lazyWithReload from "utils/lazyWithReload";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const BannerImageLazy = lazyWithReload(() => import("./messageBannerImage"));

const ActivateInvoiceForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect, values } = useWintForm<InvoiceFormTypes.ActivateInvoices>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
  });

  return (
    <>
      <WidgetBanner
        image={
          <Suspense fallback={<Skeleton width={102} style={{ background: "transparent" }}></Skeleton>}>
            <BannerImageLazy />
          </Suspense>
        }
        imageHidden="smDown"
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceActivationMessageTitle)}
        message={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceActivationMessage)}
        className={cssExports.helloGirlInfoBanner}
      />
      <WintForm {...wintFormProps}>
        <VerticalFormField<ChoiceBaseProps>
          Component={ChoiceBinary}
          {...connect("hasSentInvoiceBefore")}
          label={TranslationKeys.Invoice.HaveYouSentInvoicesBefore}
          showMainLabel
        />

        {values.hasSentInvoiceBefore === undefined ? (
          <></>
        ) : values.hasSentInvoiceBefore ? (
          <VerticalFormField<NumberInputProps>
            key={"lastInvoiceNumber"}
            Component={NumberInput}
            {...connect("lastInvoiceNumber")}
            controlLabel={TranslationKeys.Invoice.LastInvoiceNumber}
            label={TranslationKeys.Invoice.InvoiceNumber}
            descriptionText={TranslationKeys.Invoice.LastInvoiceNumberDescription}
            allowLeadingZeros={false}
            showMainLabel
          />
        ) : (
          <VerticalFormField<NumberInputProps>
            key={"preferedStartInvoiceNumber"}
            Component={NumberInput}
            {...connect("preferedStartInvoiceNumber")}
            controlLabel={TranslationKeys.Invoice.NextInvoiceNumber}
            label={TranslationKeys.Invoice.InvoiceNumber}
            descriptionText={TranslationKeys.Invoice.NextInvoiceNumberDescription}
            allowLeadingZeros={false}
            showMainLabel
          />
        )}

        <VerticalFormField<ChoiceBaseProps>
          Component={ChoiceBinary}
          {...connect("hasEUCustomers")}
          label={TranslationKeys.Invoice.InvoiceEUCustomers}
          value={values.hasEUCustomers}
          showMainLabel
        />
        <VerticalFormField<ChoiceBaseProps>
          Component={ChoiceBinary}
          {...connect("hasRegisteredForFTax")}
          label={TranslationKeys.Invoice.HasRegisteredForFTax}
          value={values.hasRegisteredForFTax}
          showMainLabel
        />
      </WintForm>
    </>
  );
};

export default forwardRef(ActivateInvoiceForm);
